export default __webpack_public_path__ + "static/media/Project-Canary-Logo-Blue.6c19c546.webp";